export default __webpack_public_path__ + "images/KU.f32b577.png";